import React, { useMemo, useState } from "react";
import Select from "react-select";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { customStyles } from "../utils/utils";

registerLocale("es", es);

const TABS = {
  POR_GESTIONAR: "por-gestionar",
  REGISTRO_HISTORICO: "registro-historico"
};

const porGestionarMock = [
  {
    idTransaccion: "1W8NE98ON...",
    eds: "20193",
    estadoDte: "Pendiente",
    tipo: "Debito",
    formaPago: "Nuevo Persona",
    fechaHora: "2026-04-03T 20:12:15",
    material: "Gas 95",
    litros: "20",
    monto: "$ VALOR",
    folio: "631311.0"
  },
  {
    idTransaccion: "2772656",
    eds: "60300",
    estadoDte: "Pendiente",
    tipo: "Otro",
    formaPago: "Otro",
    fechaHora: "2026-04-02T 18:35:16",
    material: "Diesel",
    litros: "19950",
    monto: "$ VALOR",
    folio: "None"
  },
  {
    idTransaccion: "2774585",
    eds: "60139",
    estadoDte: "Rechazado",
    tipo: "Otro",
    formaPago: "Otro",
    fechaHora: "2026-04-03T 12:18:27",
    material: "Diesel",
    litros: "1500",
    monto: "$ VALOR",
    folio: "None"
  },
  {
    idTransaccion: "2774594",
    eds: "10021",
    estadoDte: "Pendiente",
    tipo: "Debito",
    formaPago: "Nuevo Persona",
    fechaHora: "2026-04-01T 19:04:18",
    material: "Kerosene",
    litros: "1200",
    monto: "$ VALOR",
    folio: "None"
  }
];

const registroHistoricoMock = [
  {
    idTransaccion: "2769424",
    eds: "60041",
    estadoDte: "Rechazado",
    tipo: "Otro",
    formaPago: "Otro",
    fechaHora: "2026-03-30T 10:56:16",
    material: "Kerosene",
    litros: "940",
    monto: "$ VALOR",
    folio: "None"
  },
  {
    idTransaccion: "2772636",
    eds: "60300",
    estadoDte: "Pendiente",
    tipo: "Otro",
    formaPago: "Otro",
    fechaHora: "2026-04-02T 18:35:16",
    material: "Diesel",
    litros: "19950",
    monto: "$ VALOR",
    folio: "None"
  },
  {
    idTransaccion: "2774585",
    eds: "60139",
    estadoDte: "Pendiente",
    tipo: "Otro",
    formaPago: "Otro",
    fechaHora: "2026-04-03T 12:18:27",
    material: "Diesel",
    litros: "1500",
    monto: "$ VALOR",
    folio: "None"
  },
  {
    idTransaccion: "1W8NE98ON...",
    eds: "20193",
    estadoDte: "Pendiente",
    tipo: "Debito",
    formaPago: "Nuevo Persona",
    fechaHora: "2026-04-03T 20:12:15",
    material: "Gas 95",
    litros: "20",
    monto: "$ VALOR",
    folio: "631311.0",
    fechaResolucion: "dd/mm/aa"
  }
];

const VentasPropias = () => {
  const [selectedTab, setSelectedTab] = useState(TABS.POR_GESTIONAR);
  const [fechaInicio, setFechaInicio] = useState(new Date(2026, 3, 1));
  const [fechaFin, setFechaFin] = useState(new Date(2026, 3, 9));
  const [selectedEstadoDte, setSelectedEstadoDte] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedRowId, setSelectedRowId] = useState("");

  const estadoDteOptions = [
    { value: "Pendiente", label: "Pendiente" },
    { value: "Rechazado", label: "Rechazado" },
    { value: "Aceptado", label: "Aceptado" }
  ];

  const dataRows = useMemo(() => {
    const activeRows =
      selectedTab === TABS.POR_GESTIONAR ? porGestionarMock : registroHistoricoMock;

    if (!searchText.trim()) {
      return activeRows;
    }

    const lowerText = searchText.toLowerCase();
    return activeRows.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(lowerText)
      )
    );
  }, [selectedTab, searchText]);

  function changeFechaInicio(date) {
    setFechaInicio(date);
    if (fechaFin && date && fechaFin < date) {
      setFechaFin(null);
    }
  }

  return (
    <div className="ventas-propias-container">
      <div className="view-title">Administracion</div>
      <div className="view-title-separator">|</div>
      <div className="view-subtitle">Ventas Propias No Conciliadas</div>
      <hr className="title-separator-line" />

      <div className="tab-selector ventas-propias-tabs">
        <div className="sections">
          <div
            className={`section ${selectedTab === TABS.POR_GESTIONAR ? "selected" : ""}`}
            onClick={() => setSelectedTab(TABS.POR_GESTIONAR)}
          >
            Por Gestionar
          </div>
          <div
            className={`section ${
              selectedTab === TABS.REGISTRO_HISTORICO ? "selected" : ""
            }`}
            onClick={() => setSelectedTab(TABS.REGISTRO_HISTORICO)}
          >
            Registro Historico
          </div>
        </div>
        <div className="lines">
          <div className={`line ${selectedTab === TABS.POR_GESTIONAR ? "selected" : ""}`} />
          <div
            className={`line ${
              selectedTab === TABS.REGISTRO_HISTORICO ? "selected" : ""
            }`}
          />
        </div>
      </div>

      <div className="ventas-propias-filters">
        <div className="filters-left">
          <div className="filter">
            <label className="filter-title" htmlFor="fecha-inicio-input">
              FECHA INICIO<span className="red-asterisk">*</span>
            </label>
            <DatePicker
              id="fecha-inicio-input"
              locale="es"
              selected={fechaInicio}
              onChange={(date) => changeFechaInicio(date)}
              shouldCloseOnSelect={true}
              showDisabledMonthNavigation
              dateFormat="dd/MM/yyyy"
              maxDate={new Date()}
              className="ventas-propias-datepicker-input"
              wrapperClassName="ventas-propias-datepicker-wrapper"
            />
          </div>
          <div className="filter">
            <label className="filter-title" htmlFor="fecha-fin-input">
              FECHA FIN<span className="red-asterisk">*</span>
            </label>
            <DatePicker
              id="fecha-fin-input"
              locale="es"
              selected={fechaFin}
              onChange={(date) => setFechaFin(date)}
              shouldCloseOnSelect={true}
              showDisabledMonthNavigation
              dateFormat="dd/MM/yyyy"
              minDate={fechaInicio}
              maxDate={new Date()}
              className="ventas-propias-datepicker-input"
              wrapperClassName="ventas-propias-datepicker-wrapper"
            />
          </div>
          <div className="filter">
            <label className="filter-title" htmlFor="estado-dte-select">
              ESTADO DTE
            </label>
            <Select
              id="estado-dte-select"
              className="ventas-propias-select"
              value={selectedEstadoDte}
              onChange={(option) => setSelectedEstadoDte(option)}
              closeMenuOnSelect={true}
              hideSelectedOptions={false}
              options={estadoDteOptions}
              isSearchable={false}
              isClearable={true}
              placeholder="Seleccionar"
              styles={customStyles}
              width="150px"
            />
          </div>
        </div>

        <div className="filters-right">
          <div className="search-container">
            <input
              type="search"
              className="search-input"
              placeholder="Buscar..."
              value={searchText}
              onChange={(event) => setSearchText(event.target.value)}
            />
          </div>
          {selectedTab === TABS.POR_GESTIONAR && (
            <button type="button" className="main-button main-button-small">
              Gestionar Venta
            </button>
          )}
        </div>
      </div>

      {selectedTab === TABS.POR_GESTIONAR && (
        <div className="pedidos-activos-table-container ventas-propias-table-container">
          <table className="pedidos-activos-table ventas-propias-table">
            <thead>
              <tr>
                <th><div className="th-data"><div className="th-text">ID Transaccion</div></div></th>
                <th><div className="th-data w98"><div className="th-text">EDS</div></div></th>
                <th><div className="th-data w112"><div className="th-text">Estado DTE</div></div></th>
                <th><div className="th-data w98"><div className="th-text">Tipo</div></div></th>
                <th><div className="th-data w136"><div className="th-text">Forma Pago</div></div></th>
                <th><div className="th-data w132"><div className="th-text">Fecha / Hora</div></div></th>
                <th><div className="th-data w102"><div className="th-text">Material</div></div></th>
                <th><div className="th-data w98"><div className="th-text">Litros</div></div></th>
                <th><div className="th-data w134"><div className="th-text">Monto</div></div></th>
                <th><div className="th-data w104"><div className="th-text">Folio</div></div></th>
                <th><div className="th-data th-select w98"><div className="th-text">Selec.</div></div></th>
              </tr>
            </thead>
            <tr className="table-separator-row-border-top">
              <td />
            </tr>
            <tbody>
              {dataRows.map((row) => (
                <tr key={`${row.idTransaccion}-${row.eds}`} className="data">
                  <td className="align-left">{row.idTransaccion}</td>
                  <td className="align-left">{row.eds}</td>
                  <td className="align-left">{row.estadoDte}</td>
                  <td className="align-left">{row.tipo}</td>
                  <td className="align-left">{row.formaPago}</td>
                  <td className="align-left">{row.fechaHora}</td>
                  <td className="align-left">{row.material}</td>
                  <td className="align-left">{row.litros}</td>
                  <td className="align-left">{row.monto}</td>
                  <td className="align-left">{row.folio}</td>
                  <td className="radio-cell">
                    <input
                      type="radio"
                      name="ventas-propias-selected-row"
                      value={`${row.idTransaccion}-${row.eds}`}
                      checked={selectedRowId === `${row.idTransaccion}-${row.eds}`}
                      onChange={(event) => setSelectedRowId(event.target.value)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {selectedTab === TABS.REGISTRO_HISTORICO && (
        <div className="pedidos-activos-table-container ventas-propias-table-container">
          <table className="pedidos-activos-table ventas-propias-table">
            <thead>
              <tr>
                <th><div className="th-data w98"><div className="th-text">ID Transaccion</div></div></th>
                <th><div className="th-data w76"><div className="th-text">EDS</div></div></th>
                <th><div className="th-data w98"><div className="th-text">Estado DTE</div></div></th>
                <th><div className="th-data w98"><div className="th-text">Tipo</div></div></th>
                <th><div className="th-data w122"><div className="th-text">Forma Pago</div></div></th>
                <th><div className="th-data w132"><div className="th-text">Fecha / Hora</div></div></th>
                <th><div className="th-data w98"><div className="th-text">Material</div></div></th>
                <th><div className="th-data w98"><div className="th-text">Litros</div></div></th>
                <th><div className="th-data w104"><div className="th-text">Monto</div></div></th>
                <th><div className="th-data w104"><div className="th-text">Folio</div></div></th>
                <th><div className="th-data"><div className="th-text">Fecha Resolucion</div></div></th>
                <th><div className="th-data th-select w76"><div className="th-text">Accion</div></div></th>
              </tr>
            </thead>
            <tr className="table-separator-row-border-top">
              <td />
            </tr>
            <tbody>
              {dataRows.map((row) => (
                <tr key={`${row.idTransaccion}-${row.eds}`} className="data">
                  <td className="align-left">{row.idTransaccion}</td>
                  <td className="align-left">{row.eds}</td>
                  <td className="align-left">{row.estadoDte}</td>
                  <td className="align-left">{row.tipo}</td>
                  <td className="align-left">{row.formaPago}</td>
                  <td className="align-left">{row.fechaHora}</td>
                  <td className="align-left">{row.material}</td>
                  <td className="align-left">{row.litros}</td>
                  <td className="align-left">{row.monto}</td>
                  <td className="align-left">{row.folio}</td>
                  <td className="align-left">{row.fechaResolucion || "dd/mm/aa"}</td>
                  <td className="icon-cell">👁</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VentasPropias;
